'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleImageFile = exports.isBase64EncodedUrl = undefined;

var _files = require('constructicon/lib/files');

var isBase64EncodedUrl = exports.isBase64EncodedUrl = function isBase64EncodedUrl(url) {
  return (/data:image\/([a-zA-Z]*);base64,([^"]*)/.test(url)
  );
};

var handleImageFile = exports.handleImageFile = function handleImageFile(image) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';

  if (typeof window !== 'undefined') {
    var formData = new window.FormData();
    var file = isBase64EncodedUrl(image) ? (0, _files.dataURIToBlob)(image) : image;

    formData.append(name, file);

    return formData;
  }

  return Promise.reject(new Error('This method must be called from the browser'));
};